var image_upload_default = {
  "container": "oi8eS",
  "disabled": "_2Nv15",
  "imageInput": "paJjf",
  "overlay": "_70WhF",
  "text": "K1585",
  "shown": "dP-U4",
  "hide": "Auz0t",
  "spinner": "-zi7r",
  "spin": "nR2D4"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
